import { render, staticRenderFns } from "./TaxPeriodNew.vue?vue&type=template&id=41ed3518"
import script from "./TaxPeriodNew.vue?vue&type=script&lang=js"
export * from "./TaxPeriodNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports